import { getTransactionAnalytics } from '@ynap/analytics'

export const track3DSV2Fallback = (checkoutAnalytics) => ({
    event: '3DS V2 fallback',
    effect: 'fallback to 3DS V1',
    category: {
        primaryCategory: 'checkout',
        subCategory: 'payment'
    },
    transaction: getTransactionAnalytics(checkoutAnalytics)
})


export const promoSubmittedAnalytics = (code, checkoutAnalytics) => ({
    event: 'submit promo code',
    effect: 'submit a promo code',
    category: {
        primaryCategory: 'basket',
        subCategory: 'payment'
    },
    attributes: {
        promo_code: code
    },
    transaction: getTransactionAnalytics(checkoutAnalytics)
})

export const addPromoSuccessAnalytics = (code, checkoutAnalytics) => ({
    event: 'apply promo code',
    effect: 'successfully applied promo code',
    category: {
        primaryCategory: 'basket',
        subCategory: 'payment'
    },
    attributes: {
        promo_code: code
    },
    transaction: getTransactionAnalytics(checkoutAnalytics)
})

export const addPromoErrorAnalytics = (code, checkoutAnalytics) => ({
    event: 'reject promo code',
    effect: 'failed to apply promo code',
    category: {
        primaryCategory: 'basket',
        subCategory: 'payment'
    },
    attributes: {
        promo_code: code,
        error_message: 'invalid promo code provided'
    },
    transaction: getTransactionAnalytics(checkoutAnalytics)
})

export const removePromoSuccessAnalytics = (code, checkoutAnalytics) => ({
    event: 'remove promo code',
    effect: 'successfully removed promo code',
    category: {
        primaryCategory: 'basket',
        subCategory: 'payment'
    },
    attributes: {
        promo_code: code
    },
    transaction: getTransactionAnalytics(checkoutAnalytics)
})
